const routes = [{
  path: '/feiche/policy',
  component: () => import('@/views/feiche/policy'),
  name: 'feiche-policy',
  meta: {
    title: '非车政策'
  }
}, {
  path: '/feiche/approval',
  component: () => import('@/views/feiche/approval'),
  name: 'feiche-approval',
  meta: {
    title: '政策审批'
  }
}, {
  path: '/feiche/addPolicy',
  component: () => import('@/views/feiche/components/addPolicy'),
  name: 'feiche-addPolicy',
  meta: {
    title: '新增非车政策'
  }
}, {
  path: '/feiche/compilePolicy',
  component: () => import('@/views/feiche/components/addPolicy'),
  name: 'feiche-compilePolicy',
  meta: {
    title: '编辑非车政策'
  }
}, {
  path: '/feiche/policy/detail',
  component: () => import('@/views/feiche/components/addPolicy'),
  name: 'feiche-policy-detail',
  meta: {
    title: '非车政策详情'
  }
}, {
  path: '/feiche/policy/approval',
  component: () => import('@/views/feiche/components/addPolicy'),
  name: 'feiche-policy-approval',
  meta: {
    title: '政策审批'
  }
}, {
  path: '/policy/match/detail',
  component: () => import('@/views/policy/match'),
  name: 'policy-match',
  meta: {
    title: '政策管理/政策匹配详情'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/feiche/policy.js